module.exports = __webpack_public_path__ + "img/neobet_640x200.7f8d758a.png";